import { BaseRestApi, TRestErrorHandler, ISpringRestParam, IRequestConfig, RestApiResponse } from "@oceanjs/core";



export class EhpcBaseRestApi extends BaseRestApi {


  public async putCustomEndpoint<TResult, TPutPayload = never>(
    endpoint: string, data: TPutPayload, params?: ISpringRestParam, onError?: TRestErrorHandler, config?: IRequestConfig
  ): RestApiResponse<TResult> {
    const url = this.addParams(`${this.baseUrl}/${endpoint}`, params);
    return this.request<TResult>('put', url, onError, data,config);
  }
  
}
